import { Card, CardActionArea, Fade, Grid, LinearProgress, makeStyles, Typography, Zoom } from "@material-ui/core";
import { AccessTime, ArrowForward } from "@material-ui/icons";
import React, { useRef, useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import Lottie from "lottie-react";
import animation from "../../assets/congratulation-success.json";
import { green } from "@material-ui/core/colors";
import { MotionScene, MotionScreen, SharedElement, useMotion } from "react-motion-layout";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

const ModuleCard = ({ d, reports, k, setModuleView }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const ref = useRef();
  const withTransition = useMotion(`photo-${d.id}`);
  const callback = useCallback(() => /* history.push(ROUTES.MODULE.replace(":id", d.id)), [history, k] */ {
    setModuleView(k);
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  const [hover, setHover] = useState(false);
  const [isdisplayed, setIsdisplayed] = useState(false);
  const inViewport = useIntersection(ref, "-50px");
  const [isCompleted, setIsCompleted] = useState(false);

  //parametrizar para que no sea NaN y se quede a 0%
  let formationPercent = reports?.studed ? 50 : 0;
  let evalutaionPercent = reports?.evalApproved ? 50 : (reports?.currentQuestion / reports?.totalQuestions) * 50;
  evalutaionPercent = isNaN(evalutaionPercent) ? 0 : evalutaionPercent;
  let percent = reports === undefined || !isdisplayed ? 0 : formationPercent + evalutaionPercent;

  useEffect(() => {
    if (inViewport) {
      setIsdisplayed(true);
      setTimeout(() => {
        setIsCompleted((reports?.studed ? 50 : 0) + (reports?.evalApproved ? 50 : 0) === 100);
      }, 550);
    }
  }, [inViewport]);

  const update = () => {
    if (percent === 100) {
      setIsCompleted(true);
    }
  };

  return (
    <Grid item xs={12}>
      <MotionScene name={`photo-${d.id}`} onClick={withTransition(callback)}>
        <Card
          style={{
            alignSelf: "center",
            borderRadius: 9,
            transition: "all 0.25s ease",
            transform: hover && "translate3D(0,-1px,0) scale(1.03)",
            boxShadow: hover && "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
            overflow: "hidden",
          }}
          elevation={1}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <CardActionArea style={{ padding: 18 }}>
            <Grid container item xs={12} spacing={2} style={{ margin: 0 }}>
              <Grid item xs={12} md={7} container alignItems="center" className={styles.moduleCardTitle}>
                <SharedElement.Image className={styles.moduleCardIcon} style={{ marginRight: 16, height: 64, width: 64 }} alt="" src={t(d.image)} animationKey="image" />
                <SharedElement.Text animationKey="text" className={styles.moduleTitle}>
                  {t(`formation${k + 1}Name`)}
                </SharedElement.Text>
              </Grid>

              {!isCompleted ? (
                <>
                  <Grid item xs={12} md={2} container alignItems="center">
                    <AccessTime color="primary" />
                    <Typography className={styles.moduleTime}>15 min</Typography>
                  </Grid>
                  <Grid item xs={10} md={2} container alignItems="center" justify="flex-end" spacing={1}>
                    <Grid item xs={6} lg={10}>
                      <LinearProgress variant="determinate" value={percent} ref={ref} />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography>
                        <CountUp end={isdisplayed ? percent : 0} duration={0.5} onEnd={update /*setIsCompleted(percent === 100)*/} />%
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Zoom in={isCompleted} timeout={750}>
                  <Grid item xs={10} md={4} container alignItems="center" spacing={1}>
                    <FinishedAnimation />
                  </Grid>
                </Zoom>
              )}

              <Grid item xs={2} md={1} container alignItems="center" justify="flex-end">
                <ArrowForward />
              </Grid>
            </Grid>
          </CardActionArea>
        </Card>
      </MotionScene>
    </Grid>
  );
};

export default ModuleCard;

const useStyles = makeStyles((theme) => ({
  moduleCardIcon: {
    [theme.breakpoints.down("md")]: {
      marginBottom: 24,
      height: 72,
      width: 72,
    },
  },
  moduleCardTitle: {
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },
  moduleTitle: {
    font: "500 18px/28px Google Sans,Arial,sans-serif",
    color: "#3c4043",
  },
  moduleTime: {
    color: "#80868b",
    font: "400 Google Sans,Arial,sans-serif",
    paddingLeft: 6,
  },
}));

const useIntersection = (element, rootMargin) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      { rootMargin }
    );

    element.current && observer.observe(element.current);

    //return () => observer.unobserve(element.current);
  }, []);

  return isVisible;
};

const FinishedAnimation = () => {
  const lottieRef = useRef();
  const { t } = useTranslation();
  const pause = () => {};

  return (
    <Grid container justify="center" alignItems="center">
      <Lottie
        lottieRef={lottieRef}
        animationData={animation}
        style={{ height: 64, marginTop: 4, marginBottom: 4 }}
        // loop={0}
        // autoPlay={false}
        onAnimationEnd={() => pause()}
      />
      <Typography style={{ color: green[500] }}>{t("completed!")}</Typography>
    </Grid>
  );
};
